import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import useInfiniteDataQuery from '../../../hooks/useInfiniteDataQuery/useInfiniteDataQuery';
import { InfiniteDataQueryFnUtils } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { getFindClassificationTypesKey } from './classificationTypes.keys';
import classificationTypesRepository from './classificationTypes.repository';
import {
  FindClassificationTypesOutput,
  FindClassificationTypesParams,
} from './classificationTypes.types';
import onlineClassificationTypesRepository from './onlineClassificationTypes.repository';

export const useInfiniteClassificationTypesList = (params: Record<string, any>) =>
  useInfiniteDataQuery({
    limit: 20,
    queryKey: ['classification-types', 'infinite', params],
    defaultOrderBy: { name: 'ASC' },
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCountAndParams(
      (queryParams, signal) =>
        onlineClassificationTypesRepository().find(queryParams, undefined, signal),
      params,
    ),
  });

export const useFindClassificationTypes = (
  params: FindClassificationTypesParams,
  options: UseDataQueryOptions = {},
) =>
  useDataQuery<FindClassificationTypesOutput | null>(
    {
      queryKey: getFindClassificationTypesKey({ 'order[name]': 'ASC', ...params }),
      queryFn: async () => {
        const data = await classificationTypesRepository().findClassificationTypes({
          'order[name]': 'ASC',
          ...params,
        });

        if (!data.ok || !data.data) {
          return null;
        }

        return data.data;
      },
    },
    options,
  );
